import palette from "./palette";

export const FONT_WEIGHT = {
  light: 300,
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
};

const typography = {
  fontFamily: ["Montserrat", "Arial", "sans-serif"],
  h2: {
    fontSize: "1.875rem", // 30px
    fontWeight: FONT_WEIGHT.bold,
  },
  h3: {
    fontSize: "1.5rem", // 24px
    fontWeight: FONT_WEIGHT.bold,
  },
  h4: {
    fontSize: "1.25rem", // 20px
    fontWeight: FONT_WEIGHT.medium,
  },
  h5: {
    fontSize: "1.125rem", // 18px
    fontWeight: FONT_WEIGHT.semiBold,
  },
  subtitle1: {
    fontSize: "1.125rem", // 18px
    fontWeight: FONT_WEIGHT.regular,
  },
};

/**
 * Custom Typography variants
 *
 * Any variant out of https://material-ui.com/es/api/typography/ list should be here.
 * This object is exclusively used by /components/common/Typography.js component.
 */
export const CUSTOM_VARIANTS = {
  h3SemiBold: {
    variant: "h3",
    style: {
      fontSize: "1.5rem", // 24px
      fontWeight: FONT_WEIGHT.semiBold,
    },
  },
  h4Regular: {
    variant: "h4",
    style: {
      fontSize: "1.25rem", // 20px
      fontWeight: FONT_WEIGHT.regular,
    },
  },
  h4Semibold: {
    variant: "h4",
    style: {
      fontSize: "1.25rem", // 20px
      fontWeight: FONT_WEIGHT.semiBold,
    },
  },
  h5SemiBold: {
    variant: "h5",
    style: {
      fontSize: "1.125rem", // 20px
      fontWeight: FONT_WEIGHT.semiBold,
    },
  },
  h5SmallerWhite: {
    style: {
      fontSize: "1rem", // 16px
      fontWeight: FONT_WEIGHT.semiBold,
      color: palette.primary.contrastText,
    },
  },
  body1SemiBold: {
    // 16px
    variant: "body1",
    style: {
      fontWeight: FONT_WEIGHT.semiBold,
    },
  },
  body1Medium: {
    variant: "body1",
    style: {
      fontWeight: FONT_WEIGHT.medium,
    },
  },
  body1WhiteColor: {
    variant: "body1",
    style: {
      color: palette.primary.contrastText,
    },
  },
  body1PrimaryColor: {
    // 16px
    variant: "body1",
    style: {
      color: palette.text.primary,
    },
  },
  body1TertiaryColor: {
    // 16px
    variant: "body1",
    style: {
      color: palette.text.tertiary,
    },
  },
  subtitle2SemiBold: {
    variant: "subtitle2",
    style: {
      fontSize: "1rem", // 16px
      fontWeight: FONT_WEIGHT.semiBold,
    },
  },
  body2Small: {
    variant: "body1",
    style: {
      fontSize: "0.750rem", // 12px
      fontWeight: FONT_WEIGHT.regular,
    },
  },
  body2SmallSemibold: {
    variant: "body1",
    style: {
      fontSize: "0.750rem", // 12px
      fontWeight: FONT_WEIGHT.semiBold,
    },
  },
  body2SmallLight: {
    variant: "body1",
    style: {
      fontSize: "0.750rem", // 12px
      fontWeight: FONT_WEIGHT.light,
    },
  },
  bigImpact: {
    variant: "h2",
    style: {
      fontSize: "2.5rem", // 40px
    },
  },
  tableBody1: {
    variant: "body1",
    style: {
      fontSize: "0.875rem", // 14px
    },
  },
  tableBody1SemiBold: {
    variant: "body1",
    style: {
      fontWeight: FONT_WEIGHT.semiBold,
      fontSize: "0.875rem", // 14px
    },
  },
};

export default typography;
